import SoundEngine from './SoundEngine';

export default class Notification extends SoundEngine {
  play () {
    const verb = this.fx.verb(0.3);

    const aOsc = this.osc.triangle();
    const aGain = this.fx.gain();
    const aFilter = this.fx.filter();

    const aLength = 0.3;
    aOsc.frequency.setValueAtTime(880, this.now);
    aOsc.frequency.setValueAtTime(440, this.now + (aLength / 5));
    aOsc.frequency.setValueAtTime(880, this.now + (aLength / 2));
    aGain.gain.setValueAtTime(1, this.now);
    aGain.gain.linearRampToValueAtTime(0.0001, this.now + aLength);

    aOsc.connect(aGain);
    aGain.connect(aFilter);
    aFilter.connect(this.output);
    aFilter.connect(verb);

    const verbGain = this.fx.gain();
    verbGain.gain.setValueAtTime(0.4, this.now);
    verb.connect(verbGain);
    verbGain.connect(this.output);

    aOsc.start();
    aOsc.stop(this.now + aLength);
  }
}
